import React from 'react';

const useShouldShowGiftOptions = (initialState: boolean) => {
  const [shouldShowGiftOptions, setShouldShowGiftOptions] = React.useState(initialState);
  return { shouldShowGiftOptions, setShouldShowGiftOptions };
};

export default useShouldShowGiftOptions;
